module.exports = __webpack_public_path__ + "img/16.9d553a67.png";